import styled, { keyframes } from 'styled-components';
import DefaultImage from '../../../assets/img/DefaultImageUnitControlRemote.png';
import { colors } from '~/styles/colors';

const blinkAnimation = keyframes`
  0%, 100% {
    opacity: 1; // Totalmente visível
  }
  50% {
    opacity: 0; // Invisível
  }
`;

export const ContainerHeader = styled.div<{isMobile?: boolean}>`
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  margin-bottom: 20px;
  @media (max-width: 768px) {
    border-radius: 0;
    margin: 0;
  }
  height: ${(props) => (props.isMobile ? '140px' : '200px')};
`;

export const ImageHeader = styled.div`
  width: 100%;
  height: 200px;
  background-image: linear-gradient(rgba(10, 14, 39, 0.90), rgba(10, 14, 39, 0.78), rgba(10, 14, 39, 0.51)), url(${DefaultImage});
  background-size: cover;
  background-position: center;

  @media (max-width: 768px) {
    border-bottom: 1px solid ${colors.White};
  }
`;

export const LineStyle = styled.div`
  width: 0%;
  height: 0;
  background-color: #fff;
  @media (max-width: 768px) {
    width: 100%;
    height: 15px;
    background-color: #fff;
    border-radius: 17px 17px 0 0;
    position: absolute;
    bottom: 0;
  }
`;

export const ContainerPage = styled.div<{isMobile}>`
  padding: ${(props) => (props.isMobile ? '0px' : '0px 15px')};
`;

export const TextOverlay = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  transform: translate(-50%, -50%); /* Centraliza o texto horizontal e verticalmente */
  color: white;
  text-align: center; /* Centraliza o texto horizontalmente */
  z-index: 2; /* Garante que o texto fique acima da imagem */
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 32px;
  color: rgba(255, 255, 255, 1);
`;

export const Subtitle = styled.p`
  margin: 0;
  font-size: 16px;
  color: rgba(0, 185, 206, 1);
`;

export const ContainerBoxMachines = styled.div<{
    isMobile?: boolean;
    haveData?: boolean;
  }>`
  width: 100%;
  height: auto;
  background: ${(props) => (props.isMobile ? 'transparent' : 'rgba(255, 255, 255, 1)')};
  padding: ${(props) => (props.isMobile ? '0px 30px' : '0px')};
  border-radius: 15px;
  display: ${(props) => (props.haveData ? 'grid' : 'flex')};
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 20px;
  row-gap: 20px;

  @media (max-width: 768px) {
    /* Para dispositivos móveis */
    grid-template-columns: auto;
    row-gap: 8px;
  }

  @media (min-width: 769px) and (max-width: 1280px) {
    /* Para tablets */
    grid-template-columns: 1fr;
  }


  @media (min-width: 2560px) {
    /* Para telas muito largas */
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  }
`;

export const ContainerCardMachine = styled.div`
  width: 100%;
  border: 1px solid rgba(218, 218, 218, 1);
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.15);
  border-radius: 12px;
  padding: 10px 15px;
  height: 100%;
  min-height: 180px;
  display: flex;
  flex-direction: column;
  @media (max-width: 768px) {
    /* Para dispositivos móveis */
    max-width: 100%;
  }

`;

export const ArrowStyle = styled.div`
`;

export const InfoMachineSubtitles = styled.div`
  font-size: 12px;
  color: rgba(156, 156, 156, 1);
  gap: 5px;
  margin-top: 5px;
  h3 {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow-wrap: break-word;
    line-height: 1.2;
  }
`;

export const ContainerSubTitles = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
  p {
    margin: 0;
  }
`;

export const ContainerSemMaquinas = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 200px;
  position: relative;
  flex-grow: 1;
  span {
    margin: 0;
    color: rgba(10, 14, 39, 1);
  }
`;

export const BoxIconInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  div {
    display: flex;
    align-items: center;
  }
`;

export const ContainerColorEnv = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  justify-content: center;
`;

export const IconColorEnv = styled.div`
  gap: 5px;
  width: 4px;
  height: 4px;
  border-radius: 10px;
  animation: ${blinkAnimation} 2s infinite;
`;

export const TitleMachine = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
  h3 {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow-wrap: break-word;
    line-height: 1.2;
    margin: 0;
    color: rgba(10, 14, 39, 1);
    font-weight: 600;
  }

  span {
    font-size: 12px;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow-wrap: break-word;
    font-weight: 400;
  }
`;

export const TitleMachineSkeleton = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 8px;

  > div {
    flex: 1;
    margin: 0 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
`;

export const ContainerAutomaticMachines = styled.div`
  width: 100%;
  background-color: rgba(255, 255, 255, 1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border-radius: 8px;
  gap: 20px;
`;

export const LineSeparator = styled.div`
  border-top: 1px solid rgba(202, 211, 224, 1);
  height: 1px;
  width: 100%;
  margin-top: 5px;
`;

export const ThermometherArea = styled.div`
  display: flex;
  gap: 3px;
  align-items: center;
  p {
    font-size: 10px;
  }
`;

export const SearchInputCommon = styled.div<{ isDisabled?: boolean }>`
  min-height: 48px;
  font-size: 12px;
  color: ${({ isDisabled }) => (isDisabled ? 'rgba(82, 88, 102, 1)' : '#000')};
  width: 100%;
  box-sizing: border-box !important;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 0;
  border: 1px rgba(205, 208, 213, 1);
  border-radius: 16px;
  margin-bottom: 30px;
  input {
    background: ${({ isDisabled }) => (isDisabled ? '#E2E4E9' : 'rgba(255, 255, 255, 1)')};
    width: 100%;
    box-shadow: unset;
    border-radius: 8px;
    border: 1px solid rgba(205, 208, 213, 1);

  }
  div:nth-child(1) {
    width: 100%;
  }

  span {
    color: ${({ isDisabled }) => (isDisabled ? 'rgba(82, 88, 102, 1);' : 'rgba(134, 140, 152, 1)')};
  }

   @media (max-width: 768px) {
    margin-bottom: 16px;
  }
`;

export const Label = styled.span`
  transition: all 0.2s;
  margin-top: -8px;
  margin-left: 16px;
  margin-right: 16px;
  color: ${colors.Blue700};
  font-size: 11px;
  font-weight: bold;
`;

export const Clean = styled.div`
  font-size: 11px;
  line-height: 13px;
  color: #363BC4;
  text-decoration: underline;

  margin-top: 6px;

  cursor: pointer;
`;

export const AutomaticModeTitle = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  h2 {
    margin: 0;
    font-size: 18px;
    color: rgba(0, 0, 0, 1);
    font-weight: 600;
  }
  p {
    color: rgba(156, 156, 156, 1);
    font-size: 12px;
    font-weight: 400;
    margin: 0;
  }
`;

export const ContainerPagination = styled.div`
  display: flex;
  width: 100%;
  margin-top: 10px;
  padding-bottom: 20px;
  justify-content: center;

  .rc-pagination-item {
    display: inline-grid;
    align-items: center;
    border: 1px solid #E2E4E9;
    border-radius: 4px;

    a {
      color: rgba(82, 88, 102, 1);
    }
  }

  .rc-pagination-item-active {
    border: 1px solid rgba(42, 47, 134, 1);
    border-radius: 4px;
    a {
      color: #FFF;
    }
  }

  .rc-pagination-prev .rc-pagination-item-link, .rc-pagination-next .rc-pagination-item-link {
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const ErrorImg = styled.img`
width: 129px;
height: 129px;
`;

export const ContainerErrorMachines = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-height: 200px;
  position: relative;
  flex-grow: 1;
  span {
    margin: 0;
    color: rgba(10, 14, 39, 1);
  }
`;

export const ErrorMachinesButton = styled.button`
  background-color: ${colors.brand.principal};
  width: 143px;
  height: 33px;
  font-size: 11px;
  color: #FFF;
  font-weight: 500;
  border: none;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background-color: ${colors.brand.principalHover};
    color: ${colors.White};
  }
`;

export const ContainerStatusCard = styled.div`
  margin-top: 10px;
`;

export const ContainerEnvironments = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
  padding: 5px 0;
`;

export const EnvironmentCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 35px;
`;

export const EnvironmentTitle = styled.div`
  font-weight: 700;
  font-size: 11px;
  color: ${colors.Blue500};
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow-wrap: break-word;
`;

export const EnvironmentDetails = styled.div`
  display: flex;
  justify-content: space-around;
  font-size: 12px;


  div {
    display: flex;
    flex-direction: column;
    gap: 2px;
    font-weight: bold;
    text-align: center;
  }

  span {
    font-size: 12px;
    font-weight: 400;
  }
`;

export const HeaderWithSkeletonLoading = styled.div`
  width: 0%;
  height: 0;
  background-color: #fff;
  @media (max-width: 768px) {
    width: 100%;
    height: 15px;
    background-color: #fff;
    border-radius: 17px 17px 0 0;
    position: absolute;
    bottom: 0;
  }
`;

export const ContainerHeaderTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  gap: 8px;

  h2 {
    font-size: 24px;
    font-weight: 600;
    margin: 0;
  }

  span {
    color: ${colors.text['soft-400']};
    font-size: 14px;
    font-weight: 400;
  }

  @media (max-width: 768px) {
    justify-content: space-between;
    span {
      font-size: 12px;
    }
  }
`;

export const MachineSearchContainer = styled.div<{ hasError?: boolean}>`
  display: flex;
  gap: 8px;
  margin-bottom: 12px;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: ${({ hasError }) => (hasError ? '30px 10px 0px 30px' : '0px 30px')};
  }
`;

export const AvailableCountContainer = styled.div`
  display: flex;
  margin-left: auto;
`;

export const InputWrapper = styled.div<{ isDisabled?: boolean }>`
  display: flex;
  width: 30%;
  min-width: 240px;
  margin-left: ${({ isDisabled }) => (isDisabled ? 'auto' : '0')};

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const InputInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: auto;
  width: 100%;
`;
